import { render, staticRenderFns } from "./TestItemReading.vue?vue&type=template&id=7651897c&scoped=true&"
import script from "./TestItemReading.vue?vue&type=script&lang=js&"
export * from "./TestItemReading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7651897c",
  null
  
)

export default component.exports